module.exports = __webpack_public_path__ + "img/right_opening.1fa080c1.svg";